import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExitHeavy = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M10 10L30 30",
		stroke: "currentColor",
		strokeWidth: 3.3333,
		strokeMiterlimit: 10,
		strokeLinecap: "square",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M30 10L10 30",
		stroke: "currentColor",
		strokeWidth: 3.3333,
		strokeMiterlimit: 10,
		strokeLinecap: "square",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgExitHeavy);
export default ForwardRef;
